// Tipos de códigos de respuestas
exports.DONE = 200;
exports.CREATED = 201;
exports.REMOVED = 204;
exports.NOT_VALID = 400;
exports.PERMISSIONS = 401;
exports.NOT_FOUND = 404;
exports.CONFLICT = 409;
exports.DENIED_BY_ADMIN = 418;